import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Contacts.css';
import Flowers from './pics/flowercontacts.png';
import Email from './pics/email.png';
import Tg from './pics/stg.png';

export default class Home extends Component {
  render() {
    return (
      <div className="main">
        <section>
          <div className='contactscol'>
            <div className='contactscolleft'>
              <div className='contactscollefttext'>
                <p className='contactscollefttexts'>
                  свяжитесь с нами
                </p>
              </div>
              <div className='contactscolleftcont'>
                <p className='contactscolleftcontname'>
                  МЕНЕДЖМЕНТ И СОТРУДНИЧЕСТВО
                </p>
                <p className='contactscolleftcontnamet'>
                  АЛЕКСАНДРА
                </p>
                <div className='contactscolleftcontthings'>
                  <img className='contactscolleftcontthing' src={Email} alt='' />
                  <p className='contactscolleftcontthingtext'>
                    <a className='link_to_email_cont' href="mailto:lampabikt@gmail.com">
                      LAMPABIKT@GMAIL.COM
                    </a>
                  </p>
                </div>
                <div className='contactscolleftcontthings'>
                  <img className='contactscolleftcontthing' src={Tg} alt='' />
                  <p className='contactscolleftcontthingtext'>
                    <a className='link_to_tg_cont' href="https://t.me/lamp-manage" target='_blank'>
                      @LAMP-MANAGE
                    </a>
                  </p>
                </div>
              </div>
              <div className='contactscolleftcont'>
                <p className='contactscolleftcontname'>
                  ОРГАНИЗАЦИЯ ВЫСТУПЛЕНИЙ
                </p>
                <p className='contactscolleftcontnamet'>
                  СТАНИСЛАВ
                </p>
                <div className='contactscolleftcontthings'>
                  <img className='contactscolleftcontthing' src={Email} alt='' />
                  <p className='contactscolleftcontthingtext'>
                    <a className='link_to_email_cont' href="mailto:lampabikt@lineup-group.ru">
                      LAMPABIKT@LINEUP-GROUP.RU
                    </a>
                  </p>
                </div>
                <div className='contactscolleftcontthings'>
                  <img className='contactscolleftcontthing' src={Tg} alt='' />
                  <p className='contactscolleftcontthingtext'>
                    <a className='link_to_tg_cont' href="https://t.me/STANISLAVLYZHIN" target='_blank'>
                      @STANISLAVLYZHIN
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className='contactscolright'>
              <img className='contactscolrightimg' src={Flowers} alt='' />
            </div>
          </div>
          <div className='footer'>
            <div className='footerleft'>
              <div className='footerleftline'>
                <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
              </div>
              <div className='footerleftname'>
                <p className='footerleftnametext'>
                  лампабикт.
                </p>
              </div>
            </div>
            <div className='footercenter'>
              <a className='footercenterimg' />
            </div>
            <div className='footerright'>
              <div className='footerrightline'>
                <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };
};